/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBarUp = createReactComponent("outline", "arrow-bar-up", "IconArrowBarUp", [["path", { "d": "M12 4l0 10", "key": "svg-0" }], ["path", { "d": "M12 4l4 4", "key": "svg-1" }], ["path", { "d": "M12 4l-4 4", "key": "svg-2" }], ["path", { "d": "M4 20l16 0", "key": "svg-3" }]]);

export { IconArrowBarUp as default };
//# sourceMappingURL=IconArrowBarUp.mjs.map
